import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    class: "flex-grow-1 bg-transparent",
    style: { "flex": "1 1 auto", "overflow-y": "auto", "min-height": "200px" }
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 1,
    class: "container"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "col-12 container" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "col-1 color__text-primary text-center pt-1" };
const _hoisted_8 = {
    key: 0,
    class: "bi bi-check-square-fill"
};
const _hoisted_9 = {
    key: 1,
    class: "bi bi-square"
};
const _hoisted_10 = { class: "col-9 d-flex" };
const _hoisted_11 = { class: "col-2 text-center" };
const _hoisted_12 = { class: "row small fst-italic" };
const _hoisted_13 = { class: "col-11" };
const _hoisted_14 = { class: "list-inline list-pipe" };
const _hoisted_15 = { key: 0 };
const _hoisted_16 = { key: 1 };
const _hoisted_17 = { key: 2 };
const _hoisted_18 = { key: 3 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_loader2 = _resolveComponent("g-loader2");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: _ctx.$t('account.Command.Select'),
        "class-window": "d-flex",
        "class-content": "content__no-marging"
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: _ctx.$t('shared.Text.Show'),
                onClick: _ctx.onGotoAccount,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["text", "onClick"]),
            _createVNode(_component_g_button, {
                text: _ctx.$t('shared.Text.Close'),
                onClick: _ctx.currentWindow?.close,
                type: "normal",
                class: "w-120-px"
            }, null, 8, ["text", "onClick"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_g_loader2, {
                            size: "100px",
                            color: "secondary",
                            "is-active": _ctx.isLoading
                        }, null, 8, ["is-active"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAccounts, (account) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: "row border-bottom g-account-select__item cursor-pointer p-2 ps-4 pe-4",
                                onClick: _withModifiers(($event) => (_ctx.onSelect(account)), ["stop", "prevent"])
                            }, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", _hoisted_7, [
                                            (_ctx.accountID === account.accountID)
                                                ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                                                : (_openBlock(), _createElementBlock("i", _hoisted_9))
                                        ]),
                                        _createElementVNode("div", _hoisted_10, _toDisplayString(account.displayName), 1),
                                        _createElementVNode("div", _hoisted_11, _toDisplayString(account.konto), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-1" }, null, -1)),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createElementVNode("ul", _hoisted_14, [
                                                (account.address?.name1)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_15, _toDisplayString(account.address?.name1), 1))
                                                    : _createCommentVNode("", true),
                                                (account.address?.name2)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_16, _toDisplayString(account.address?.name2), 1))
                                                    : _createCommentVNode("", true),
                                                (account.address?.addition)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, _toDisplayString(account.address?.addition), 1))
                                                    : _createCommentVNode("", true),
                                                (account.address?.street)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_18, _toDisplayString(account.address?.street), 1))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("li", null, _toDisplayString(account.address?.country) + " " + _toDisplayString(account.address?.zipCode) + " " + _toDisplayString(account.address?.city), 1)
                                            ])
                                        ])
                                    ])
                                ])
                            ], 8, _hoisted_4));
                        }), 256))
                    ]))
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
